import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireExternal({ children }: { children: React.ReactNode }) {
  const { external, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!external) {
    return <Navigate to="/gast" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <>{children}</>;
}
